function isObjectEqual(first, second) {
  const al = Object.getOwnPropertyNames(first);
  const bl = Object.getOwnPropertyNames(second);
  if (al.length !== bl.length) return false;
  const hasAllKeys = al.every((value) => !!bl.find((v) => v === value));
  if (!hasAllKeys) return false;

  for (const key of al) if (first[key] !== second[key]) return false;
  return true;
}

export const DEFAULT_SEARCH_EMPTY_MESSAGE =
  "No items found by that filter criteria.";

export const DEFAULT_EMPTY_MESSAGE = "No items found, try creating one.";

export const getEmptyStateMessage = (
  currentFilters,
  defaultFilters,
  defaultEmptyMessage = DEFAULT_EMPTY_MESSAGE,
  defaultSearchEmptyMessage = DEFAULT_SEARCH_EMPTY_MESSAGE
) => {
  const hasFilters = !isObjectEqual(currentFilters, defaultFilters);
  let message = defaultEmptyMessage;
  if (hasFilters) {
    message = defaultSearchEmptyMessage;
  }
  return message;
};
